import { Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const createPatientSchema = z.object({
  code: z.string().min(1, 'Il codice è obbligatorio'),
});

type CreatePatientFormValues = z.infer<typeof createPatientSchema>;

interface CreatePatientModalProps {
  opened: boolean;
  onClose: () => void;
  onCreate: (code: string) => Promise<void>;
  loading?: boolean;
}

export function CreatePatientModal({
  opened,
  onClose,
  onCreate,
  loading = false,
}: CreatePatientModalProps) {
  const form = useForm<CreatePatientFormValues>({
    resolver: zodResolver(createPatientSchema),
    defaultValues: {
      code: '',
    },
  });

  const handleClose = () => {
    form.reset({
      code: '',
    });
    onClose();
  };

  const handleSubmit = form.handleSubmit(async values => {
    await onCreate(values.code);
    handleClose();
  });

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title='Aggiungi nuovo utente'
      centered
      size='md'
      closeOnClickOutside={!loading}
      closeOnEscape={!loading}
    >
      <form onSubmit={handleSubmit}>
        <Stack gap='md'>
          <Text size='sm' c='dimmed'>
            Inserisci il codice dell'utente da aggiungere.
          </Text>

          <TextInput
            label='Codice utente'
            placeholder='Inserisci il codice utente'
            required
            {...form.register('code')}
            error={form.formState.errors.code?.message}
            disabled={loading}
          />

          <Group justify='flex-end' gap='xs' mt='md'>
            <Button variant='subtle' onClick={handleClose} disabled={loading}>
              Annulla
            </Button>
            <Button type='submit' loading={loading}>
              Crea
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
